import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from "../../services/hooks";
import { loginWithGoogleCode } from "../../services/login/actions";

export function GoogleOAuthCallback(): JSX.Element {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const startedRef = React.useRef(false);

  useEffect(() => {
    if (startedRef.current) {
      return;
    }

    startedRef.current = true;
    const queryString = location.search;

    if (!queryString) {
      navigate("/login", { replace: true });
      return;
    }

    Promise.resolve(dispatch(loginWithGoogleCode(queryString) as any))
      .then(() => {
        navigate("/", { replace: true });
      })
      .catch(() => {
        navigate("/login", { replace: true });
      });
  }, [dispatch, location, navigate]);

  return (
    <div>
    </div>
  );
}
